import React from "react";
import ReactDOM from "react-dom";
import { Navbar, Nav, NavItem, NavDropdown, MenuItem, Col } from "react-bootstrap";
import { IndexLinkContainer, LinkContainer } from "react-router-bootstrap";
import clothingBrands from "../../data/clothing-brands.js";
import carSeatBrands from "../../data/car-seat-brands.js";
import "./Header.css";

class Header extends React.Component {

  componentDidMount() {
    const navBar = ReactDOM.findDOMNode(this);
    const collapsibleNav = navBar.querySelector("div.navbar-collapse");
    const btnToggle = navBar.querySelector("button.navbar-toggle");

    navBar.addEventListener("click", (evt) => {
      if (evt.target.tagName !== "A" || evt.target.classList.contains("dropdown-toggle") || ! collapsibleNav.classList.contains("in")) {
        return;
      }

      btnToggle.click();
    }, false);
  }

  render() {
    return(
      <Navbar fixedTop>
        <Navbar.Header>
          <Navbar.Brand>
            <a href="/welcome">FIT MY KID</a>
          </Navbar.Brand>
          <Navbar.Toggle>
            MENU <i className="fa fa-bars"></i>
          </Navbar.Toggle>
        </Navbar.Header>
        <Navbar.Collapse className="text-primary">
          <Nav>
            <IndexLinkContainer to={{ pathname: "/" }}>
              <NavItem eventKey={1} href="/">Size Finder</NavItem>
            </IndexLinkContainer>
            <NavDropdown eventKey={5} title="Size Charts" id="basic-nav-dropdown" >
              <MenuItem header>Clothing</MenuItem>
              <div className="container">
                { clothingBrands.map(
                  (brand, index) =>
                    <Col md={5} key={brand.key}>
                      <LinkContainer to={"/clothes/" + brand.key}>
                        <NavItem eventKey={"5." + index}
                          href={"/clothes/" + brand.key}>
                          {brand.name}
                        </NavItem>
                      </LinkContainer>
                    </Col>)
                }
              </div>

              <MenuItem divider />
              <MenuItem header>Car Seats</MenuItem>
              <div className="container">
                {
                  carSeatBrands.map(
                    (brand, index) =>
                      <Col md={5} key={brand.key}>
                        <LinkContainer to={"/car-seats/" + brand.key} key={brand.key}>
                          <NavItem eventKey={"6." + index}
                            href={"/car-seats/" + brand.key}>
                            {brand.name}
                          </NavItem>
                        </LinkContainer>
                      </Col>
                  )
                }
              </div>
            </NavDropdown>
            <LinkContainer to={{ pathname: "/settings" }}>
              <NavItem eventKey={3} href="/settings">Settings</NavItem>
            </LinkContainer>
            <LinkContainer to={{ pathname: "/about" }}>
              <NavItem eventKey={2} href="/about">About</NavItem>
            </LinkContainer>
            <LinkContainer to={{ pathname: "/contact" }}>
              <NavItem eventKey={4} href="/contact">Contact</NavItem>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/Header.js
 **/